<template>
	<div class="admin-data-table">
		<input-text v-model="searchString" name="search" placeholder="Search" v-if="table_rows.length"/>
		<div class="idi-table data-table" v-if="table_rows.length">
			<div class="idi-header" :style="rowStyle">
				<div class="idi-cell" :class="{ sortable: column.field }" v-for="column in table_columns" :key="column.field" @click="onSort(column.field)">
					<span>{{ column.label }}</span>
					<span v-if="column.field == sort.field"> {{ sort.order == 'asc' ? '▲' : '▼' }}</span>
				</div>
			</div>
			<div class="idi-row" :style="rowStyle" v-for="(row, rowKey) in filteredData" :key="rowKey">
				<div :class="`idi-cell grid-area-${column.field}`" v-for="(column, columnKey) in row.columns" :key="columnKey">
					<span v-if="!column.type">{{ column.value }}</span>
					<a v-if="column.type == 'email'" :href="`mailto:${column.value}`">{{ column.value }}</a>
					<router-link v-if="column.type == 'link'" :to="column.value.to">{{ column.value.title }}</router-link>
					<button-icon v-if="column.type == 'operation'" :to="column.value.to" icon="edit" :title="column.value.title"/>
					<div v-if="column.type == 'operations'" class="context-menu" @click.stop="toggleVisibility($event)">
						<div class="context-menu-items">
							<router-link v-for="value in column.value" :key="value.title" :to="value.to">{{ value.title }}</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<p v-if="finished && !table_rows.length">No records found.</p>
	</div>
</template>

<script>
import { debounce } from 'debounce'
import Fuse from 'fuse.js'
export default {
	props: {
		finished: {
			type: Boolean,
			default: false
		},
		table_columns: {
			type: Array,
			default: () => []
		},
		table_rows: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			sort: {
				field: 'id',
				order: 'asc' // asc, desc
			},
			// search
			searchString: '',
			fuseSearchString: '',
			debouncedFilterData: null,
			// fuse.js options
			options: {
				shouldSort: true,
				threshold: 0.6,
				location: 0,
				distance: 100,
				maxPatternLength: 32,
				minMatchCharLength: 1,
				keys: [
					'columns.value'
				]
			},
			fuse: null,
		}
	},
	computed: {
		rowStyle () {
			let res = 'grid-template-columns:'
			for (let c in this.table_columns) {
				res += this.table_columns[c].width ? ` ${this.table_columns[c].width}` : ' 1fr'
			}
			return res
		},
		filteredData () {
			return (this.fuse && this.fuseSearchString) ? this.fuse.search(this.fuseSearchString) : this.table_rows
		},
	},
	watch: {
		table_rows: {
			handler () {
				this.fuse = new Fuse(this.table_rows, this.options)
			},
			immediate: true,
			deep: true
		},
		searchString () {
			this.debouncedFilterData()
		}
	},
	methods: {
		onSort (field = null) {
			if (!field) return
			if (this.sort.field == field) {
				this.sort.order = this.sort.order == 'asc' ? 'desc' : 'asc'
			}
			else {
				this.sort.field = field
				this.sort.order = 'asc'
			}
			this.sort.order == 'asc' ? this.sortAsc(field) : this.sortDesc(field)
		},
		sortAsc (field) {
			this.table_rows.sort((a, b) => {
				const valueA = (a.columns.find(ele => ele.field == field)).value
				const valueB = (b.columns.find(ele => ele.field == field)).value
				if (valueA < valueB) return -1
				if (valueA > valueB) return 1
				return 0
			})
		},
		sortDesc (field) {
			this.table_rows.sort((a, b) => {
				const valueA = (a.columns.find(ele => ele.field == field)).value
				const valueB = (b.columns.find(ele => ele.field == field)).value
				if (valueA > valueB) return -1
				if (valueA < valueB) return 1
				return 0
			})
		},
		filterData () {
			this.fuseSearchString = this.searchString
		},
		toggleVisibility (event) {
			const target = event.target
			target.classList.contains('active') ? target.classList.remove('active') : target.classList.add('active')
		},
		closeVisible () {
			let elements = document.getElementsByClassName('context-menu active')
			for (let i = 0; i < elements.length; i++) {
				elements[i].classList.remove('active')
			}
		}
	},
	created () {
		this.debouncedFilterData = debounce(this.filterData, 200)
	},
	mounted () {
		window.addEventListener('click', this.closeVisible)
	},
	beforeDestroy () {
		window.removeEventListener('click', this.closeVisible)
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AdminDataTable.vue